const Instructions = ({ title, instructions, note, titleLeft }) => {
    return (
        <div className="waitinglistflowpage__instruction__container">
            <h3
                className={`waitinglistflowpage__instruction__title ${
                    titleLeft ? "text-left" : ""
                }`}
            >
                {title}
            </h3>
            <ol className="waitinglistflowpage__instruction__subpoint-list">
                {(instructions || []).map((sub, subIdx) => (
                    <li
                        key={subIdx}
                        className="waitinglistflowpage__instruction__subpoint-item"
                    >
                        {sub}
                    </li>
                ))}
            </ol>
            <p className="waitinglistflowpage__instruction__note">{note}</p>
        </div>
    );
};

export default Instructions;
